import React from 'react'
import Image from 'gatsby-image'
import styled from 'styled-components'
import media from '../styles/media'
import Truncate from 'react-truncate';
import '../assets/css/fonts.css'
import '../assets/css/bootstrap.min.css'
import 'font-awesome/css/font-awesome.css'

const ContainerNews = styled.div`
  margin-bottom: 30px;
  display: inline-block;
  margin: 15px;
  background-color: #fff;
  border-radius: 0;
  overflow: hidden;
  width: 488px;
  height: 470px;
  font-size: 18px;
  p {
    text-align: center;
    padding: 0px 5px;
  }
  ${media.sm`
    width: 100%;
    height: auto;
    margin: 10px 0;
  `};

`


const ImageNew = styled(Image)`
  ${media.sm`
    max-width: 100%;
  `};

`
const News = styled.div`
  text-align: center;
  .titleItemNews {
    color: #0000e2;
    font-size: 25px;
    font-family: 'Prelo Slab';
    text-align: center;
  }

  .date {
    color: #6f6f6e;
    font-family: 'Prelo-Book';
    font-size: 14px;
  }

  .text {
    color: #6f6f6e;
    font-family: 'Prelo-Book';
    font-size: 16px;
  }
`
const New = ({ id, name, date, description, image }) => {
  return (
    <ContainerNews>
      <ImageNew resolutions={image.node.childImageSharp.resolutions} alt={name} />
      <News>
        <p className="titleItemNews" dangerouslySetInnerHTML={{ __html: name }} />
        <p className="date" dangerouslySetInnerHTML={{ __html: date }} />
        <Truncate width={900} ellipsis={<span>... </span>}>
          <p className="text" dangerouslySetInnerHTML={{ __html: description }} />
        </Truncate>
      </News>
    </ContainerNews>
  )
}

export default New
